"use strict";

exports.__esModule = true;
exports.isPrivate = exports.isBlocked = exports.getCurrentUserRole = exports.isOwner = exports.getCurrentUserCounters = exports.getCurrentUserSlug = exports.getCurrentUserSiteMemberId = exports.getCurrentUserId = exports.getCurrentUser = void 0;

var _lodash = require("lodash");

var _reselect = require("reselect");

var _userPrivacyStatus = require("../constants/user-privacy-status");

var _appsConfig = require("@wix/communities-universal/dist/src/constants/appsConfig");

var getCurrentUser = function getCurrentUser(state) {
  return (0, _lodash.get)(state, 'auth.currentUser');
};

exports.getCurrentUser = getCurrentUser;
var getCurrentUserId = (0, _reselect.createSelector)([getCurrentUser], function (currentUser) {
  return currentUser && currentUser._id;
});
exports.getCurrentUserId = getCurrentUserId;
var getCurrentUserSiteMemberId = (0, _reselect.createSelector)([getCurrentUser], function (currentUser) {
  return currentUser && currentUser.siteMemberId;
});
exports.getCurrentUserSiteMemberId = getCurrentUserSiteMemberId;
var getCurrentUserSlug = (0, _reselect.createSelector)([getCurrentUser], function (currentUser) {
  return currentUser && currentUser.slug;
});
exports.getCurrentUserSlug = getCurrentUserSlug;
var getCurrentUserCounters = (0, _reselect.createSelector)([getCurrentUser], function (currentUser) {
  return currentUser && currentUser.counters;
});
exports.getCurrentUserCounters = getCurrentUserCounters;
var isOwner = (0, _reselect.createSelector)([getCurrentUser], function (currentUser) {
  return Boolean(currentUser && currentUser.isOwner);
});
exports.isOwner = isOwner;
var getCurrentUserRole = (0, _reselect.createSelector)([getCurrentUser], function (currentUser) {
  return (0, _lodash.get)(currentUser, "appStore[" + _appsConfig.BLOG_APP_ID + "].permissions.role", 'guest');
});
exports.getCurrentUserRole = getCurrentUserRole;
var isBlocked = (0, _reselect.createSelector)([getCurrentUser], function (currentUser) {
  return Boolean(currentUser && currentUser.isBlocked);
});
exports.isBlocked = isBlocked;
var isPrivate = (0, _reselect.createSelector)([getCurrentUser], function (currentUser) {
  return currentUser && currentUser.privacyStatus === _userPrivacyStatus.USER_PRIVACY_STATUS_PRIVATE;
});
exports.isPrivate = isPrivate;